import AuthenticationForm from "./AuthenticationForm";
import Modal from "components/Modal";

function AuthenticationSecurityModal({ open, onClose, status, onSuccess }) {
  const title = status
    ? "غیر فعال کردن Authentication"
    : "فعال کردن Authentication";
  return (
    <Modal dir="rtl" maxWidth="sm" title={title} open={open} onClose={onClose}>
      <AuthenticationForm
        status={status}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </Modal>
  );
}

export default AuthenticationSecurityModal;
